module.exports = __webpack_public_path__ + "static/media/abt_icon2.ac923384.svg";